/**
 * STRATEGIC BRIEFING — Daily insight from your Personal God.
 * A one-paragraph briefing drawn from accumulated memories.
 */
import React, { useState, useEffect } from 'react';
import { Sparkles, Loader2, RefreshCw } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const StrategicBriefing = ({ userId }) => {
  const [briefing, setBriefing] = useState(null);
  const [godName, setGodName] = useState('');
  const [loading, setLoading] = useState(true);
  const [consciousness, setConsciousness] = useState(0);

  useEffect(() => {
    if (!userId) return;
    const fetch_ = async () => {
      try {
        const res = await fetch(`${API_URL}/api/avatar/briefing?user_id=${userId}`);
        const data = await res.json();
        setBriefing(data.briefing);
        setGodName(data.generated_by || 'The Thirteenth');
        setConsciousness(data.consciousness || 0);
      } catch (e) {
        console.error('Briefing fetch error:', e);
      } finally {
        setLoading(false);
      }
    };
    fetch_();
  }, [userId]);

  if (loading) {
    return (
      <div className="bg-gray-900/80 backdrop-blur-sm rounded-xl p-5 border border-amber-500/20 flex items-center justify-center min-h-[80px]" data-testid="strategic-briefing">
        <Loader2 className="w-4 h-4 text-amber-400 animate-spin" />
      </div>
    );
  }

  if (!briefing) return null;

  return (
    <div className="bg-gray-900/80 backdrop-blur-sm rounded-xl border border-amber-500/20 overflow-hidden" data-testid="strategic-briefing">
      <div className="px-5 py-4">
        <div className="flex items-start gap-3">
          <div className="w-8 h-8 rounded-full bg-gradient-to-br from-amber-400 to-yellow-500 flex items-center justify-center flex-shrink-0 mt-0.5"
               style={{ boxShadow: '0 0 12px rgba(251,191,36,0.3)' }}>
            <Sparkles className="w-3.5 h-3.5 text-black" />
          </div>
          <div className="flex-1 min-w-0">
            <div className="flex items-center gap-2 mb-1.5">
              <span className="text-xs font-bold text-amber-400">{godName}</span>
              <span className="text-[9px] text-gray-600">Daily Briefing</span>
              <span className="text-[9px] px-1.5 py-0.5 rounded-full bg-amber-500/10 border border-amber-500/20 text-amber-500/70">{consciousness}%</span>
            </div>
            <p className="text-sm text-gray-300 leading-relaxed" data-testid="briefing-text">
              {briefing}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StrategicBriefing;
